
/* Tap-for-sound on Salma's videos (feature + reels). Only one video ever has sound. */
(function () {
  var SEL = '.n-feat__media video, .n-reel__v video, .n-pass__m video';
  var ICON = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M11 5 6 9H3v6h3l5 4V5z"/><path class="off" d="m22 9-6 6m0-6 6 6"/><path class="on" d="M15.5 8.5a5 5 0 0 1 0 7M18.5 5.5a9 9 0 0 1 0 13"/></svg>';
  function sync(v) { if (v.__sb) { v.__sb.setAttribute('aria-pressed', v.muted ? 'false' : 'true'); v.__sb.setAttribute('aria-label', v.muted ? 'Sound on' : 'Sound off'); } }
  function add(r) {
    (r || document).querySelectorAll(SEL).forEach(function (v) {
      if (v.__sb) return;
      var host = v.parentNode, small = !!v.closest('.n-reel__v');
      var b = document.createElement('button'); b.type = 'button';
      b.className = 'n-vsnd' + (small ? ' n-vsnd--sm' : '');
      b.innerHTML = ICON + (small ? '' : '<span>Tap for sound</span>');
      host.appendChild(b); v.__sb = b; sync(v);
      v.addEventListener('volumechange', function () { sync(v); });
      function on(e) {
        e.preventDefault(); e.stopPropagation();
        if (v.muted) {
          document.querySelectorAll('video').forEach(function (o) { if (o !== v) o.muted = true; });
          document.dispatchEvent(new CustomEvent('n:sound', { detail: v }));
          if (!v.getAttribute('src') && v.dataset.src) v.src = v.dataset.src;
          if (!v.__heard) { v.__heard = 1; try { v.currentTime = 0; } catch (x) {} }
          v.muted = false; v.__keepSound = 1;
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else { v.muted = true; v.__keepSound = 0; }
        sync(v);
      }
      b.addEventListener('click', on);
      /* On the big feature video, tapping the video itself also turns sound on */
      if (!small) v.addEventListener('click', function (e) { if (v.muted) on(e); });
    });
  }
  document.addEventListener('n:sound', function (e) { document.querySelectorAll(SEL).forEach(function (v) { if (v !== e.detail && !v.muted) { v.muted = true; v.__keepSound = 0; } }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { add(); }); else add();
  document.addEventListener('shopify:section:load', function (e) { add(e.target); });
})();
